import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';

export default class Coin extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.isGood = false;
    this.speed = 400;
    this.isActive = true;
    this.isAlive = true;

    this.showJr = false;
    this.num = -1;
    this.vY = 0;

    this.coinbg = ABCyaPhaser.Images.addImage(0, 0, 'coin', this);

    this.workingWidth = this.coinbg.getBounds().width;
    this.workingHeight = this.coinbg.getBounds().height;

    if (gameData.GAME_TYPE === 'jr') {
      this.showJr = true;
    }
    else {
      this.showJr = false;
      this.lblNum = this.scene.add.bitmapText(0, -6, 'asapBold', '1', 34).setTintFill('0xd3681b')
        .setOrigin(.5)
        .setCenterAlign();
      this.add(this.lblNum);
    }
    this.boundries = {
      left: this.x - this.workingWidth / 2,
      right: this.x + this.workingWidth / 2,
      top: this.y - this.workingHeight / 2,
      bottom: this.y + this.workingHeight / 2
    };
  }

  reset(num, isCorrect, startX, startY) {
    this.scale = 1;
    this.isActive = true;
    this.isAlive = true;
    this.num = num;
    this.isGood = isCorrect;
    if (this.showJr) {
      this.coinbg.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, num);
    }
    else {
      this.lblNum.text = num.toString();
    }

    this.setVisible(true);

    this.x = startX;
    this.y = startY;
  };

  collected() {
    this.isActive = false;
    if (this.isGood) {
      ABCyaPhaser.Tweens.addTween(this, 820, { scale: 0.4, x: 80, y: 16 }, Phaser.Math.Easing.Quadratic.In, () => {
        this.selfDestruct();
      });
    }
    else {
      ABCyaPhaser.Tweens.addTween(this, 420, { scale: 0 }, Phaser.Math.Easing.Quadratic.In, () => {
        this.selfDestruct();
      });
    }
  };

  selfDestruct() {
    this.isAlive = false;
    this.setVisible(false);
  };

  update(e, trackSpeedMod) {
    let tSpeed = !trackSpeedMod ? 0 : trackSpeedMod;
    this.baseSpeed = -60;
    if (tSpeed < 94) tSpeed = 94;
    this.vY = this.baseSpeed + tSpeed;// - (this.speedMod * trackSpeedMod);

    if (this.vY < 0) this.vY = 0;
    const dtime = e / 1000;
    this.y += this.vY * dtime;
    this.boundries.left = this.x - this.workingWidth / 2;
    this.boundries.right = this.x + this.workingWidth / 2;
    this.boundries.top = this.y - this.workingHeight / 2;
    this.boundries.bottom = this.y + this.workingHeight / 2;
  };
}